module.exports = {
  title: '车型管理',
  route: {
    path: '/platform-goods-manage',
    children: {
      path: 'vehicles-type-manage',
    },
  },
};
